package com.appsyde.shared.presentation.screen.component.history

import androidx.compose.runtime.Composable
import com.appsyde.contract.clearText.EmailBodyCleaner
import com.appsyde.shared.modules.ticket.domain.model.Direction
import com.appsyde.shared.modules.ticket.domain.model.TicketHistoryItem
import com.appsyde.shared.modules.ticket.domain.model.TicketOriginalHistoryItem
import com.appsyde.shared.presentation.screen.component.history.helper.formatHistoryTime
import com.appsyde.shared.presentation.style.style.AppStylesMessages
import org.jetbrains.compose.web.dom.*

@Composable
fun HistorySummaryItemRow(item: TicketHistoryItem) {
    val isInbound = item.direction == Direction.INBOUND.toString()
    val bubbleClass = if (isInbound) AppStylesMessages.bubbleClient else AppStylesMessages.bubbleAI

    Div(attrs = { classes(AppStylesMessages.messageRow) }) {
        Div(attrs = { classes(AppStylesMessages.messageColumn) }) {
            Div(attrs = { classes(AppStylesMessages.clientMessageMeta) }) {
                Span(attrs = { classes(AppStylesMessages.clientMetaTag) }) {
                    Text(if (isInbound) "Client" else "Message envoyé")
                }
                Span(attrs = { classes(AppStylesMessages.metaSeparator) }) { Text("•") }
                Span(attrs = { classes(AppStylesMessages.clientMetaTime) }) { Text(formatHistoryTime(item.sentAtMs)) }
            }
            Div(attrs = { classes(bubbleClass) }) {
                Div(attrs = { classes(AppStylesMessages.bubbleContent) }) {
                    Text(item.summary.orEmpty().ifBlank { "Résumé non disponible" })
                }
            }
        }
    }
}

@Composable
fun HistoryOriginalItemRow(item: TicketOriginalHistoryItem) {
    val isInbound = item.direction == Direction.INBOUND.toString()
    val bubbleClass = if (isInbound) AppStylesMessages.bubbleClient else AppStylesMessages.bubbleAI

    val content = when {
        !item.error.isNullOrBlank() -> "⚠️ ${item.error}"
        !item.body.isNullOrBlank() -> EmailBodyCleaner.compactParagraphsForDisplay(
            EmailBodyCleaner.cleanInboundBodyForAi(item.body, maxChars = 12_000)
        )
        !item.snippet.isNullOrBlank() -> item.snippet
        else -> "—"
    }

    Div(attrs = { classes(AppStylesMessages.messageRow) }) {
        Div(attrs = { classes(AppStylesMessages.messageColumn) }) {
            Div(attrs = { classes(AppStylesMessages.clientMessageMeta) }) {
                Span(attrs = { classes(AppStylesMessages.clientMetaTag) }) {
                    Text(if (isInbound) "Client" else "Message envoyé")
                }
                Span(attrs = { classes(AppStylesMessages.metaSeparator) }) { Text("•") }
                Span(attrs = { classes(AppStylesMessages.clientMetaTime) }) { Text(formatHistoryTime(item.sentAtMs)) }
            }
            Div(attrs = { classes(bubbleClass) }) {
                Div(attrs = { classes(AppStylesMessages.bubbleContent) }) {
                    Text(content)
                }
            }
        }
    }
}
